<template>
    <div id="map_cnt" class="col_map"></div>
</template>

<script>
export default {
    data() {
        return {
            propertyWindow: null,
            infoWindow: null,
            MarkerWithLabel: null,
        };
    },
    computed: {
        coords() {
            return this.$store.getters.getCoords;
        },
        property_ads() {
            return this.$store.getters.getAds;
        },
    },
    watch: {
        property_ads: {
            handler(newVal) {
                if (newVal.length > 0) {
                    this.addMarkers();
                }
            },
        }
    },
    mounted() {
        this.markers = [];
        this.map = null;
        this.initMap();
    },
    methods: {
        initMap() {
            mapboxgl.accessToken = 'pk.eyJ1IjoiZHllZ29uZXJ5IiwiYSI6ImNqdzgzMWpiMjJsN3Q0MG1tODE1YThjdXYifQ.edguOQs5PzWymNRTBXScNw';
            // Store map as non-reactive property
            this.map = new mapboxgl.Map({
                container: 'map_cnt',
                style: 'mapbox://styles/mapbox/streets-v12',
                center: [this.coords.lng, this.coords.lat],
                zoom: 12,
            });
            this.map.addControl(new mapboxgl.NavigationControl(), 'bottom-right');
            this.map.on('load', () => {
                this.map.resize();
                this.renderMap();
            });
        },
        renderMap: function() {
            window.dataLayer.push({
                'event': 'gmaps_usage',
                'event_category': 'search_map',
                'event_label': 'gmaps_usage',
            });

            ['moveend', 'zoomend'].forEach(event => this.map.on(event, () => this.handleMapChanged(event)))
            if (this.property_ads.length > 0) {
                this.addMarkers();
            }
        },
        handleMapChanged: function (event) {
            // Use Mapbox GL API for getting bounds
            let bounds = this.map.getBounds();
            this.$store.commit('setBounds', {
                minLat: bounds.getSouthWest().lat,
                maxLat: bounds.getNorthEast().lat,
                minLng: bounds.getSouthWest().lng,
                maxLng: bounds.getNorthEast().lng,
            });
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
            this.$store.commit('setPage', 1);
            this.$store.dispatch('filterResults').then(res => {
                this.addMarkers();
                this.registerSearchEvent();
            });
        },
        registerSearchEvent() {
            window.dataLayer.push({
                'event': 'search',
                'event_category': 'search_page',
                'event_label': 'search_results',
                'search_location': this.location,
                'search_type': 'map',
                'search_results': this.property_ads.length
            });
        },
        clearMarkers: function () {
            // Clear Mapbox markers
            this.markers.forEach(marker => marker.remove());
            this.markers = [];
        },
        addMarkers: function () {
            let _this = this;

            // Clear existing markers first
            this.clearMarkers();

            for (let index = 0; index < this.property_ads.length; index++) {
                const element = this.property_ads[index];
                if (element.weight < 1) {
                    continue;
                }
                var position = [parseFloat(element.lng), parseFloat(element.lat)];

                // Create custom marker element with bubble
                const markerEl = document.createElement('div');
                markerEl.className = 'popup-container';

                const bubbleAnchor = document.createElement('div');
                bubbleAnchor.className = 'popup-bubble-anchor';

                const content = document.createElement('div');
                content.id = 'bubble_container';
                content.className = 'popup-bubble';
                content.innerHTML = element.rent_price;

                bubbleAnchor.appendChild(content);
                markerEl.appendChild(bubbleAnchor);

                // Create Mapbox marker with custom element
                const marker = new mapboxgl.Marker(markerEl)
                    .setLngLat(position)
                    .addTo(this.map);

                // Create popup content for click
                const popupContent = `
                    <div id="prop_window">
                        <a class="img_lnk" target="_blank" href="${element.url}">
                            <div class="prop-image" style="background-image: url(${element.main_photo}); background-size: cover; background-position: center;"></div>
                            <div class="prop_content">
                                <p class="price_label text-success"><b>${element.rent_price} por mês</b></p>
                                <h5 class="text-overflow m-b-0">${element.title}</h5>
                                <p class="text-muted text-overflow">
                                    <i class="fas fa-map-marker-alt m-r-5"></i>${element.location}
                                </p>
                            </div>
                        </a>
                    </div>
                `;

                // Create Mapbox popup
                const popup = new mapboxgl.Popup({ offset: 25 })
                    .setHTML(popupContent);

                // Set popup to marker (this handles the click event automatically)
                marker.setPopup(popup);

                // Add hover events
                marker.getElement().addEventListener('mouseenter', function (e) {
                    this.classList.add('hovered');
                });

                marker.getElement().addEventListener('mouseleave', function (e) {
                    this.classList.remove('hovered');
                });

                this.markers.push(marker);
            }
        },
    },
};
</script>

<style lang="scss">
@import "../../../sass/variables";
.col_map {
    position: fixed !important;
    width: 40%;
    right: 0;
    height: calc(100% - 250px);
    top: 250px;
}

.popup-bubble {
    /* Position the bubble centred-above its parent. */
    position: absolute;
    top: 0;
    left: 0;
    transform: translate(-50%, -100%);
    /* Style the bubble. */
    background-color: white;
    padding: 5px;
    border-radius: 3px;
    font-family: sans-serif;
    overflow-y: auto;
    max-height: 60px;
    font-weight: 600;
    font-size: 13px;
    transition: all 0.2s;
    border: solid 2px $brand-custom;
    background: #FFF;
    color: #666;
    z-index: 1;
    box-shadow: 1px 2px 5px 0 rgba(49, 58, 70, 0.65);
}

.mapboxgl-popup-content {
    height: 260px
}

.popup-container.hovered .popup-bubble {
    background: $brand-custom;
    color: #FFF;
    cursor: pointer;
    z-index: 2;
}

.popup-bubble-anchor {
    position: absolute;
    width: 100%;
    bottom: /* TIP_HEIGHT= */ 8px;
    left: 55px;
}

/* This element draws the tip. */
.popup-bubble-anchor::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    /* Center the tip horizontally. */
    transform: translate(-50%, 0);
    /* The tip is a https://css-tricks.com/snippets/css/css-triangle/ */
    width: 0;
    height: 0;
    /* The tip is 8px high, and 12px wide. */
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-top: /* TIP_HEIGHT= */ 8px solid $brand-custom;
}

/* JavaScript will position this div at the bottom of the popup tip. */
.popup-container {
    cursor: auto;
    height: 40px;
    position: absolute;
    /* The max width of the info window. */
    width: 100px;
}

.popup-container.hovered {
    z-index: 8000 !important;
}

#prop_window {
    background: #FFF;
    max-width: 320px;
    width: 100%;

    .img_lnk {
        height: auto;
        width: 100%;
        display: block;
    }

    .prop-image {
        display: block;
        height: 160px;
        width: auto;
        max-width: 100%;
        position: relative;
        overflow: hidden;
        margin: 0 auto;
        margin-bottom: 10px;
    }

}
</style>
